import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';

import { ExpressionCascadeButton } from 'bones/components/molecules/QueryBuilder/ExpressionCascadeButton';
import { FilterRow } from 'bones/components/molecules/QueryBuilder/FilterRow';
import { useQueryBuilderSchemaContext } from 'bones/components/molecules/QueryBuilder/hooks/useQueryBuilderSchema';
import { DatatypeOperatorTypeValue } from 'bones/utils/queryBuilder/constants';
import { PropertySubSelectItem } from 'bones/utils/queryBuilder/helpers/select';
import { Variable } from 'bones/utils/queryBuilder/types';

export interface ExpressionCascadeProps {
  expressionIdx: number;
  filterIdx: number;
  onRemoveFilter: () => void;
  onSelectComparisonProperty: (item: PropertySubSelectItem) => void;
  onSelectComparisonSubject: (item: Variable) => void;
  onSelectOperator: (
    type: DatatypeOperatorTypeValue,
    comparison: boolean
  ) => void;
  onSelectProperty: (item: PropertySubSelectItem) => void;
  onSelectSubject: (item: Variable) => void;
  onSetValue: (value: string | Variable) => void;
  subExpressionIdx: number;
}

export const ExpressionCascade: React.VFC<ExpressionCascadeProps> = ({
  expressionIdx,
  filterIdx,
  onRemoveFilter,
  onSelectComparisonProperty,
  onSelectComparisonSubject,
  onSelectOperator,
  onSelectProperty,
  onSelectSubject,
  onSetValue,
  subExpressionIdx,
}) => {
  const { colors, testIds, readOnly } = useQueryBuilderSchemaContext();
  return (
    <div
      className="sd-query-builder-expression-cascade"
      data-testid={testIds.expressionCascade}
    >
      {readOnly ? null : (
        <ExpressionCascadeButton
          hoverIcon={IconNames.DELETE}
          iconColor={colors.darkIcon}
          onClick={onRemoveFilter}
          testId={testIds.removeExpressionCascadeButton}
        />
      )}
      <FilterRow
        expressionIdx={expressionIdx}
        filterIdx={filterIdx}
        onSelectComparisonProperty={onSelectComparisonProperty}
        onSelectComparisonSubject={onSelectComparisonSubject}
        onSelectOperator={onSelectOperator}
        onSelectProperty={onSelectProperty}
        onSelectSubject={onSelectSubject}
        onSetValue={onSetValue}
        subExpressionIdx={subExpressionIdx}
      />
    </div>
  );
};
